/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../constants';
import axios from "axios";
import Select from 'react-select';
import config from '../../../config/config';
import TileComp from '../../ProcureToPayComp/TileComp/TileComp';
import styles from './TransitionSLADashboardComp.module.css';
import './TransitionSLADashboardComp.css';
import OverallTransitionSummaryCharts from '../OverallTransitionSummaryCharts/OverallTransitionSummaryCharts';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import HorizontalProgressChart from '../HorizontalProgressChart/HorizontalProgressChart';
import ReusableTable from '../../ReusableTable/ReusableTable';

import EntityStatusComparisonChart from '../EntityStatusComparisonChart/EntityStatusComparisonChart';
import TitleWithDetailedClick from '../TitleWithDetailedClick/TitleWithDetailedClick';

import SimpleBarChart from '../simpleChart/simpleChart';

const { API_BASE_URL } = config;

const TransitionSLADashboardComp = () => {

  const { showPopup } = usePopupManager();
  const location = useLocation();
  const initialFilters = location.state || {
    inOutData: [],
    locationData: [],
    subDivisionData: [],
    yearData: [],
    quarterData: [],
  };

  const [filters, setFilters] = useState(initialFilters);
  const [showDashboard, setShowDashboard] = useState(false);
  const [showMainDashboard, setShowMainDashboard] = useState(false);
  const [detailedButtonClick, setDetailedButtonClick] = useState(false);

  const [InOutOptions, setInOutOptions] = useState([]);
  const [LocationOptions, setLocationOptions] = useState([]);
  const [SubDivisionOptions, setSubDivisionOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [quarterOptions, setQuarterOptions] = useState([]);
  const [entityOptions, setEntityOptions] = useState([]);
  const [InOut, setInOut] = useState([]);
  const [Location, setLocation] = useState([]);
  const [SubDivision, setSubDivision] = useState([]);
  const [Year, setYear] = useState([]);
  const [Quarter, setQuarter] = useState([]);
  const [overall, setOverall] = useState([]);
  // const [entity, setEntity] = useState([entityOptions[0]]);
  const [entity, setEntity] = useState([]);
  const [showTowerWise, setShowTowerWise] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [PreSlaAchievedMissed, setPreSlaAchievedMissed] = useState([]);
  const [PostSlaAchievedMissed, setPostSlaAchievedMissed] = useState([]);
  const [SLADetailTable, setSLADetailTable] = useState([]);
  const [SLADetailTableCSV, setSLADetailTableCSV] = useState([]);
  const [SLADetailTableCount, setSLADetailTableCount] = useState([]);
  const [PreSLAEntityWise, setPreSLAEntityWise] = useState([]);
  const [PostSLAEntityWise, setPostSLAEntityWise] = useState([]);
  const [PostSLATowerWise, setPostSLATowerWise] = useState([]);
  const [PreSLATowerWise, setPreSLATowerWise] = useState([]);

  const [hasApplied, setHasApplied] = useState(false);

  const [towerOptions, settowerOptions] = useState([]);
  const [towerselected, settowerselected] = useState([]);

  const [PONumberOptions, setPONumberOptions] = useState([]);
  const [PONumberselected, setPONumberselected] = useState([]);

  const [selectedPage, setSelectedPage] = useState();

  const [startPage, setStartPage] = useState(0);
  const [endPage, setEndPage] = useState(100);

  const [selectedEntityName, setSelectedEntityName] = useState([]);
  const [selectedTowerName, setselectedTowerName] = useState([]);

  const [actualStatusselected, setactualStatusselected] = useState([]);
  const [actualstatusOptions, setactualstatusOptions] = useState([]);

  const [transitionLeadselected, settransitionLeadselected] = useState([]);
  const [transitionLeadOptions, settransitionLeadOptions] = useState([]);

  const itemsPerPage = 100;

  const handleInOutChange = (selected) => {
    // setInOut(selected);
    setInOut(selected || []);
    setFilters(prev => ({ ...prev, inOutData: selected }));
  };

  const handleLocationChange = (selected) => {
    // setLocation(selected);
    setLocation(selected || []);
    setFilters(prev => ({ ...prev, locationData: selected }));
  };

  const handleSubDivisionChange = (selected) => {
    // setSubDivision(selected);
    setSubDivision(selected || []);
    setFilters(prev => ({ ...prev, subDivisionData: selected }));
  };

  // const handleYearChange = (selected) => {
  //   // setYear(selected);
  //   setYear(selected || []);
  //   setFilters(prev => ({ ...prev, yearData: selected }));
  // };

  // const handleYearChange = (selected) => {
  //   const updatedYear = selected || [];
  //   setYear(updatedYear);
  //   setFilters(prev => ({ ...prev, yearData: updatedYear }));

  //   if (updatedYear.length === 0) {
  //     setQuarter([]);
  //     setFilters(prev => ({ ...prev, quarterData: [] }));
  //   }
  // };

  const handleYearChange = (selected) => {
    if (!selected) {
      setYear([]);
      setQuarter([]);
      setFilters(prev => ({ ...prev, yearData: [], quarterData: [] }));
      return;
    }
    const updatedYear = [selected];
    setYear(updatedYear);
    setFilters(prev => ({ ...prev, yearData: updatedYear }));
    setQuarter([]);
    setFilters(prev => ({ ...prev, quarterData: [] }));
  };

  const handleQuarterChange = (selected) => {
    // setQuarter(selected);
    setQuarter(selected || []);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };

  const handleTowerChange = (selected) => {
    const selectedArray = selected || [];
    settowerselected(selected || []);
    setFilters(prev => ({ ...prev, towerData: selected }));
    const selectedtowerNames = selectedArray.map(e => e.label);
    setselectedTowerName(selectedtowerNames.join(', '));
};

const handleActualStatusChange = (selected) => {
  // setLocation(selected);
  setactualStatusselected(selected || []);
  setFilters(prev => ({ ...prev, locationData: selected }));
};

const handleTransitionLeadChange = (selected) => {
  // setLocation(selected);
  settransitionLeadselected(selected || []);
  setFilters(prev => ({ ...prev, locationData: selected }));
};

  const fetchInOutOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-in-out`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setInOutOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchLocationOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-location`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setLocationOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchSubDivisionOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-sub-division`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setSubDivisionOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchQuerterOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-quarter`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setQuarterOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-entity`, {
        headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' },
      });
      const data = response.data || [];
      setEntityOptions(data);
      // if (data.length > 0) {
      //   setEntity([data[0]]);
      //   setSelectedEntityName(data[0].label);
      // }
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchTowerOptions = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/transition-tower`, {
            headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
        })
            .then((response) => {
                settowerOptions(response.data);
            })
    } catch (error) {
        console.error('Error fetching entity options:', error);
    }
  };

  const fetchActualstatusOptions = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/transition-Actual-status`, {
            headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
        })
            .then((response) => {
                setactualstatusOptions(response.data);
            })
    } catch (error) {
        console.error('Error fetching entity options:', error);
    }
  };

  const fetchTransitionLeadOptions = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/transition-transition-lead`, {
            headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
        })
            .then((response) => {
              settransitionLeadOptions(response.data);
            })
    } catch (error) {
        console.error('Error fetching entity options:', error);
    }
  };


  useEffect(() => {
    fetchInOutOptions();
    fetchLocationOptions();
    fetchSubDivisionOptions();
    fetchYearOptions();
    fetchQuerterOptions();
    fetchEntityOptions();
    fetchTowerOptions();
    fetchActualstatusOptions();
    fetchTransitionLeadOptions();
    // console.log("main page filter check -------------->", filters);
  }, []);

  const handleApply = () => {
    // if (Year.length === 0) {
    //   showPopup({
    //     type: MESSAGE_TYPE.INFORMATION,
    //     contextText: MESSAGE_TYPE.INFORMATION,
    //     info: "Please select a Financial Year before applying filters.",
    //   });
    //   return;
    // }
    // if (InOut?.length > 0 || Location?.length > 0 || SubDivision?.length > 0 || Year?.length > 0 || Quarter?.length > 0) {
      const selectedEntity = entity.map(e => e.value);
      const inoutFilterData = InOut.map(e => e.value);
      const locationFilterData = Location.map(e => e.value);
      const subDivisionFilterData = SubDivision.map(e => e.value);
      const yearFilterData = Year.map(e => e.value);
      const quarterData = Quarter.map(e => e.value);
      const TOWERS = towerselected.map(e => e.value);
      const po_number = PONumberselected.map(e => e.value);
      const actualStatus = actualStatusselected.map(e => e.value);
      const transitionLead = transitionLeadselected.map(e => e.value);
    setIsLoading(true);

    const fetchTransitionFirst = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/transition-SLA-Dashboard`,
          {
            selectedInout: inoutFilterData,
            selectedLocation: locationFilterData,
            selectedEntity: selectedEntity,
            selectedSubDiv: subDivisionFilterData,
            selectedYear: yearFilterData,
            selectedQuarter: quarterData,
            selectedTower:TOWERS,
            selectedPONumber:po_number,
            selectedActualstatus: actualStatus,
            selectedTranLead: transitionLead,
            start: startPage,
            end: endPage,
          },
          {
            headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' }
          }
        );

        const data = response.data;
        // console.log("test check submit", response.data);
        setPreSlaAchievedMissed(data.Pre_SLA_Achieved);
        setPostSlaAchievedMissed(data.Post_Trans_SLA_Achieved);
        setSLADetailTable(data.FinanceSLADetailTable.tableData);
        setSLADetailTableCSV(data.FinanceSLADetailTable.tableCSV);
        setSLADetailTableCount(data.FinanceSLADetailTable.tableCount);
        setPreSLAEntityWise(data.Pre_SLA_EntityWise);
        setPostSLAEntityWise(data.Post_SLA_EntityWise);
        setPostSLATowerWise(data.Post_SLA_TowerWise);
        setPreSLATowerWise(data.Pre_SLA_TowerWise);
      } catch (error) {
        console.error('Error fetching total tiles data:', error);
      }
    };

    Promise.all([
      fetchTransitionFirst(),
    ]).then(() => {
      setShowDashboard(true);
      setShowMainDashboard(true);
      setDetailedButtonClick(false);
      setIsLoading(false);
    });
    // }
    // else {
    //   showPopup({
    //     type: MESSAGE_TYPE.INFORMATION,
    //     contextText: MESSAGE_TYPE.INFORMATION,
    //     info: "Please select atleast one filter value.",
    //   });
    // }
  };

  const handleReset = () => {
    setInOut([]);
    setLocation([]);
    setSubDivision([]);
    setYear([]);
    setEntity([]);
    setQuarter([]);
    settowerselected([]);
    setPONumberselected([]);
    setSelectedEntityName([]);
    setselectedTowerName([]);
    setactualStatusselected([]);
    settransitionLeadselected([]);
    setFilters({
      inOutData: [],
      locationData: [],
      subDivisionData: [],
      yearData: [],
      quarterData: [],
    });
    setHasApplied(false);
    setShowDashboard(false);
    setShowMainDashboard(false);
    setDetailedButtonClick(false);
    setSelectedPage(1);
    setStartPage(0);
    setEndPage(100);
  };

  const handlePageChange = (page) => {
    setHasApplied(true)
    setSelectedPage(page);
    let endPageVal = page * 100
    let startPageVal = endPageVal - 99

    setStartPage(startPageVal)
    setEndPage(endPageVal)
  };

  useEffect(() => {
    if (hasApplied) {
      handleApply();
    }
  }, [selectedPage,hasApplied]);

  const handleEntity = (selected) => {
    const selectedArray = selected || [];
    setEntity(selectedArray);
    const selectedEntityNames = selectedArray.map(e => e.label);
    setSelectedEntityName(selectedEntityNames.join(', '));
  };

  useEffect(() => {
    setOverall({ value: 'overall', label: 'Overall summary' });
  }, []);

  const customStylesMultiSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const PreSLALabel = PreSlaAchievedMissed.map(i => i[0]);
  // const PoValues = [190, 110, 300];
  const PreSlaDataset = [
    {
      label: "FTE's Count",
      data: PreSlaAchievedMissed.map(i => i[1]),
      backgroundColor: [
        '#4bc0c0',
        '#ff6384',
        '#ffd000',
        '#4f90bc',
        '#8f51ca',
      ],
      borderColor: [
        '#4bc0c0',
        '#ff6384',
        '#ffd000',
        '#4f90bc',
        '#8f51ca',
      ],
      borderWidth: 1,
    }
  ]

  const PostSLALabel = PostSlaAchievedMissed.map(i => i[0]);
  // const PoValues = [190, 110, 300];
  const PostSlaDataset = [
    {
      label: "FTE's Count",
      data: PostSlaAchievedMissed.map(i => i[1]),
      backgroundColor: [
        '#4bc0c0',
        '#ff6384',
        '#ffd000',
        '#4f90bc',
        '#8f51ca',
      ],
      borderColor: [
        '#4bc0c0',
        '#ff6384',
        '#ffd000',
        '#4f90bc',
        '#8f51ca',
      ],
      borderWidth: 1,
    }
  ]

  // const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
  // const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
  // const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
  // const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
  // const emeraldGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';
  // const varinceGradient = 'linear-gradient(135deg, #EC4899 0%, #d595b5ff 100%)';

  const columns = [
    { header: "Legal Entity", accessor: "legal_entity" },
    { header: "Tower", accessor: "tower" },
    { header: "Work Area", accessor: "work_area" },
    { header: "Actual Status", accessor: "actual_status" },
    { header: "Budgeted FTE's No's", accessor: "budgeted_fte_nos" },
    { header: "Budget Go Live Month", accessor: "budget_go_live_month" },
    { header: "Actual FTE's No's", accessor: "actual_fte_nos" },
    { header: "Billing Go Live Month", accessor: "billing_go_live_month" },
    { header: "Pre SLA Achieved SLA Missed", accessor: "pre_sla_achieved_sla_missed" },
    { header: "Post Transiton SLA Achieved Missed", accessor: "post_transiton_sla_achieved_missed" },
    { header: "SLA Missed Reason", accessor: "sla_missed_reason" },
  ]

  const [totalRecords, setTotalRecords] = useState(0);
  const [dataLoading, setdataLoading] = useState(false);

  const handleCSVDownload = () => {
    const csvHeader = columns.map(col => col.header).join(',');
    const csvRows = SLADetailTableCSV.map(row =>
      columns.map(col => `"${(row[col.accessor] || '').replace(/"/g, '""')}"`).join(',')
    );
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Transition_SLA_Detail.csv';
    link.click();
  };

  const PreSLAEntityWiseLabel = PreSLAEntityWise.map(i => i[0]);

  const PreSLAentityActualFTEs = {
    label: "Actual FTEs",
    data: PreSLAEntityWise.map(i => i[1]),
    backgroundColor: "#1f77b4",
  }
  const PreSLAentityBudgetedFTEs = {
    label: "Budgeted FTEs",
    data: PreSLAEntityWise.map(i => i[2]),
    backgroundColor: "#ff7f0e",
  }

  const PostSLAEntityWiseLabel = PostSLAEntityWise.map(i => i[0]);

  const PostSLAentityActualFTEs = {
    label: "Actual FTEs",
    data: PostSLAEntityWise.map(i => i[1]),
    backgroundColor: "#00b588",
  }
  const PostSLAentityBudgetedFTEs = {
    label: "Budgeted FTEs",
    data: PostSLAEntityWise.map(i => i[2]),
    backgroundColor: "#a4038e",
  }


  const POSTSLAtowerWiseLabels = PostSLATowerWise.map(i => i[0]);
  const POSTSLAtowerWiseActual = {
    label: "Actual FTE's",
    data: PostSLATowerWise.map(i => i[1]),
    backgroundColor: "#00b588",
  }

  const POSTSLAtowerWiseBudgeted = {
    label: "Budgeted FTE's",
    data: PostSLATowerWise.map(i => i[2]),
    backgroundColor: "#a4038e",
  }

  const PreSLAtowerWiseLabels = PreSLATowerWise.map(i => i[0]);
  const PreSLAtowerWiseActual = {
    label: "Actual FTE's",
    data: PreSLATowerWise.map(i => i[1]),
    backgroundColor: "#1f77b4",
  }

  const PreSLAtowerWiseBudgeted = {
    label: "Budgeted FTE's",
    data: PreSLATowerWise.map(i => i[2]),
    backgroundColor: "#ff7f0e",
  }

  const handleDetailClick = () => {
    setDetailedButtonClick(true);
    setShowMainDashboard(false);
  }

  const handleMainPageClick = () => {
    setDetailedButtonClick(false);
    setShowMainDashboard(true);
  }

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>IN/OUT</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={InOut}
                onChange={handleInOutChange}
                options={InOutOptions}
                closeMenuOnSelect={false}
                isMulti
                isSearchable={true}
                placeholder="Select IN/OUT"
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Location</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Location}
                onChange={handleLocationChange}
                options={LocationOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Location"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Legal Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                placeholder={<div className="select-placeholder-text">Select Legal Entity</div>}
                onChange={handleEntity}
                options={entityOptions}
                // isSearchable={false}
                isMulti
                isSearchable={true}
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Sub-Division</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={SubDivision}
                onChange={handleSubDivisionChange}
                options={SubDivisionOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Sub-Division"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Tower</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={towerselected}
                onChange={handleTowerChange}
                options={towerOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Tower"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
        </div>
        <div className={styles.filter_panel_row} style={{ paddingTop: "10px" }}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Financial Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Year}
                onChange={handleYearChange}
                options={yearOptions}
                // isMulti
                isSearchable={true}
                placeholder="Select Financial Year"
                // closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Quarter}
                onChange={(selected) => {
                  if (Year.length === 0) {
                    showPopup({
                      type: MESSAGE_TYPE.INFORMATION,
                      contextText: MESSAGE_TYPE.INFORMATION,
                      info: "Please select Financial Year first before selecting Quarter.",
                    });
                    return;
                  }
                  handleQuarterChange(selected);
                }}
                options={quarterOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Quarter"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
                isDisabled={Year.length === 0}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Actual status</label>
              <div className={styles.filter_select_wrapper}>
                  <Select
                      value={actualStatusselected}
                      onChange={handleActualStatusChange}
                      options={actualstatusOptions}
                      isMulti
                      isSearchable={true}
                      placeholder="Actual Status"
                      closeMenuOnSelect={false}
                      styles={customStylesMultiSelect}
                  />
              </div>
          </div>
          <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Transition Lead</label>
              <div className={styles.filter_select_wrapper}>
                  <Select
                      value={transitionLeadselected}
                      onChange={handleTransitionLeadChange}
                      options={transitionLeadOptions}
                      isMulti
                      isSearchable={true}
                      placeholder="Transition Lead"
                      closeMenuOnSelect={false}
                      styles={customStylesMultiSelect}
                  />
              </div>
          </div>
          <div className={styles.filter_panel_col}>
            <div className={styles.filter_select_wrapper}>
              <div className="filter-panel-col">
                <button onClick={handleApply} className="btn apply-btn">
                  Apply
                </button>
                <button onClick={handleReset} className="btn reset-btn">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>

          </div>
        </div>
      )}
      {showDashboard && (
        <>
          <div>
            {showMainDashboard && (
              <div>
                <TitleWithDetailedClick
                  // title="SLA Summary"
                  title={selectedEntityName && selectedTowerName ? `${selectedEntityName}  ${selectedTowerName} SLA Summary` : "Overall SLA Summary"}
                  handleDetailClick={handleDetailClick}
                />
                <div className="row">
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Pre SLA Trend" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                      <SimpleBarChart
                        labels={PreSLALabel}
                        dataValues={PreSlaDataset}
                        showTable={true}
                      />
                    </DashboardSection>
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Post Transition SLA Trend" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                      <div>
                        <SimpleBarChart
                          labels={PostSLALabel}
                          dataValues={PostSlaDataset}
                          showTable={true}
                        />
                      </div>
                    </DashboardSection>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-12">
                    <DashboardSection title="SLA Details" disableDetailView={true} detailPath="" infoIcondata="Mannual CSV Data">
                      <ReusableTable
                        data={SLADetailTable} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={SLADetailTableCount} handleCSVDownload={handleCSVDownload} currentPage={selectedPage ? selectedPage - 1 : 0} 
                      />
                    </DashboardSection>
                  </div>
                </div>
              </div>
            )}
            {/* after click on detailed page */}
            {detailedButtonClick && (
              <div>
                <TitleWithDetailedClick
                  // title="Detailed View"
                  title={selectedEntityName && selectedTowerName ? `${selectedEntityName}  ${selectedTowerName} Detailed View` : "Detailed View"}
                  handleBackClick={handleMainPageClick}
                  showBackButton={true}
                  showDetailedButton={false}
                />
                <div className="row">
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Pre SLA Entity wise Drilldown" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                      <EntityStatusComparisonChart
                        title={selectedEntityName}
                        labels={PreSLAEntityWiseLabel}
                        actualFTEs={PreSLAentityActualFTEs}
                        budgetedFTEs={PreSLAentityBudgetedFTEs}
                      />
                    </DashboardSection>
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                  <DashboardSection title="Post SLA Entity wise Drilldown" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                      <EntityStatusComparisonChart
                        title={selectedEntityName}
                        labels={PostSLAEntityWiseLabel}
                        actualFTEs={PostSLAentityActualFTEs}
                        budgetedFTEs={PostSLAentityBudgetedFTEs}
                      />
                    </DashboardSection>
                    {/* <DashboardSection title="Pre SLA Tower Wise Drilldown" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters}>
                      <div>
                        <HorizontalProgressChart data={chartDataProgress} />
                        <HorizontalProgressChart
                          labels={PreSLAtowerWiseLabels}
                          actualFTEs={PreSLAtowerWiseActual}
                          budgetedFTEs={PreSLAtowerWiseBudgeted}
                          heightValues={250}
                        />
                      </div>
                    </DashboardSection> */}
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-12 col-lg-12 mb-3">
                    <DashboardSection title="SLA Details" disableDetailView={true} detailPath="">
                      <ReusableTable
                        data={dataDetailed} columns={columnsDetailed} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={handleCSVDownload} dataLoading={dataLoading}
                      />
                    </DashboardSection>
                  </div>
                  <div className="col-12 col-lg-6 mb-3">

                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Post SLA Tower Wise Drilldown" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters}>
                      <div>
                      <HorizontalProgressChart
                          labels={POSTSLAtowerWiseLabels}
                          actualFTEs={POSTSLAtowerWiseActual}
                          budgetedFTEs={POSTSLAtowerWiseBudgeted}
                          heightValues={250}
                        />
                      </div>
                    </DashboardSection>
                  </div>
                </div> */}
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default TransitionSLADashboardComp;
